import React, { Component } from 'react'
import mh from '../../assets/mh.png';
import p from '../../assets/p.png';
import sss from '../../assets/sss.png';
import silc from '../../assets/silc.png';
export default class index extends Component {
    render() {
        return (
            <div style={{ padding: 20, }}>
                <center>
                    <h1 style={{ fontSize: 120, lineHeight: 0.01 }}>Mental health</h1>
                    <h1>ดัชนีวัดสุขภาพจิต</h1>
                    <hr style={{ width: '80%' }}></hr>
                </center>
                <div style={{ marginLeft: '15%' }}>
                    <h1>นโยบายข้อมูล</h1>
                    <p>นโยบายนี้จะอธิบายถึงข้อมูลที่เราประมวลผลเพื่อสนับสนุน Mental health (ดัชนีวัดสุขภาพจิต) ในการเก็บข้อมูลเกี่ยวกับสุขภาพจิตของ จังหวัดอุบลราชธานี</p>
                    <li>การเก็บข้อมูล</li>
                    <p style={{ marginLeft: 50 }}>จัดเก็บข้อมูลส่วนตัวและรูปถ่ายเพื่อยืนยันตัวตนในการเข้าใช้งาน</p>
                    <p style={{ marginLeft: 50 }}>จัดเก็บข้อมูลส่วนตัวและผลการสำรจต สุขภาพจิต ของผู้ที่ถูกสำรวจ</p>
                    <li>การใช้ข้อมูล</li>
                    <p style={{ marginLeft: 50 }}>นำข้อมูลสุขภาพจิตที่ได้ทำการสำรวจมาวิเคราะห์ เพื่อสร้างเครื่องมือ หรือ เพื่อพัฒนาบุคคล สภาพแวดล้อม เพื่อให้เกิดสุขภาพจิตที่ดีขึ้น</p>

                </div>

                <center>
                    <hr style={{ width: '80%' }}></hr>
                    <div style={{ padding: 20, }}>
                        <img src={mh} style={{ width: 200, height: 200 }}></img>
                        <img src={sss} style={{ width: 200, height: 200 }}></img>
                        <img src={p} style={{ width: 200, height: 200 }}></img>
                        <img src={silc} style={{ width: 200, height: 200 }}></img>
                    </div>
                    <div id="foot">
                        <h3>โครงการพัฒนารูปแบบการเสริมสร้างสุขภาพจิตคนจนเมือง พื้นที่ อุบลราชธานี</h3>
                        <h4>พัฒนาโดย นายอดิศร ราชชิต email: adion.ra.56@ubu.ac.th</h4>
                    </div>

                </center>


            </div>
        )
    }
}
